import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class BooksService extends BitfApiService {
  constructor(public injector: Injector) {
    super('books', injector);
  }
}
